import { useEffect } from 'react'
import '../DocumentPage.css'

const InEditorTesting = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>In-Editor Testing</h1>
        <p className="lead">
          Test your Variable Modding System configuration directly in the Unreal Engine editor.
        </p>

        <h2>Opening the Test Environment</h2>
        <p>To test your variables in the editor:</p>
        <ol>
          <li>Open your level in the Unreal Editor</li>
          <li>Click the "Play" button in the toolbar</li>
          <li>Select "Selected Viewport" or "New Editor Window"</li>
        </ol>

        <h2>Debugging Variables</h2>
        <p>Use the built-in debugging tools:</p>
        <ul>
          <li><strong>Output Log</strong>: View variable values and changes</li>
          <li><strong>Blueprint Debugger</strong>: Step through variable logic</li>
          <li><strong>Watch Window</strong>: Monitor specific variables in real-time</li>
        </ul>

        <h2>Common Testing Scenarios</h2>
        <h3>Testing Variable Updates</h3>
        <p>Verify that variables update correctly when modified.</p>

        <h3>Testing Data Table Loading</h3>
        <p>Ensure CSV data loads properly on level start.</p>

        <h3>Testing Variable Access</h3>
        <p>Confirm blueprints can read and write variables as expected.</p>

        <h2>Troubleshooting</h2>
        <ul>
          <li>Check the Output Log for errors</li>
          <li>Verify data table paths are correct</li>
          <li>Ensure variables are properly initialized</li>
        </ul>
      </div>
    </div>
  )
}

export default InEditorTesting
